<i18n>
{
	"en": {
			"noPriceLines": "There are no pricelines yet."
	},
	"no": {
			"noPriceLines": "Det er ingen prislinjer ennå."
	}
}
</i18n>
<template>
	<t-no-content-panel
		:text="$t('noPriceLines')"
		icon="dollar"
		iconType="bp"
	/>
</template>

<script>
export default { name: 'PriceLines' };
</script>

